import { resolveInteractiveRoomUrl } from '@interactive-room';

export interface GuideKnowledgeBasePayload {
  text: string;
  fileName: string;
  charCount?: number;
  method?: string;
  truncated?: boolean;
}

async function readJson<T extends Record<string, unknown>>(resp: Response): Promise<T> {
  const text = await resp.text();
  try {
    return JSON.parse(text) as T;
  } catch {
    throw new Error('invalid_server_response');
  }
}

function fileToBase64(file: File): Promise<string> {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => {
      const result = String(reader.result || '');
      const base64 = result.includes(',') ? result.split(',')[1] : result;
      resolve(base64);
    };
    reader.onerror = () => reject(new Error('file_read_failed'));
    reader.readAsDataURL(file);
  });
}

export async function extractGuideMaterialContext(
  file: File,
  baseUrl?: string,
): Promise<GuideKnowledgeBasePayload> {
  const fileBase64 = await fileToBase64(file);
  const resp = await fetch(`${resolveInteractiveRoomUrl(baseUrl)}/api/guides/context/extract`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      fileBase64,
      fileName: file.name,
      mimeType: file.type,
    }),
  });

  const json = await readJson<{
    ok?: boolean;
    error?: string;
    text?: string;
    fileName?: string;
    charCount?: number;
    method?: string;
    truncated?: boolean;
  }>(resp);

  if (!resp.ok || !json.ok || !json.text) {
    throw new Error(json.error || 'extract_context_failed');
  }

  return {
    text: json.text,
    fileName: json.fileName || file.name,
    charCount: json.charCount,
    method: json.method,
    truncated: json.truncated,
  };
}
